import dateHelper from '../../../utils/portuna/dateHelper';

export function getMonday(today: Date = new Date(), removeDays: number = 0)
{
    let monday = new Date(today);
    let day    = monday.getDay();
    let diff   = monday.getDate() - day + (day == 0 ? -6 : 1);

    return dateHelper('Y-m-d', new Date(monday.setDate(diff - removeDays))) as string;
}

export interface EvaluationLegend
{
    title: string
    icon: string
    iconClass: string
}

export const EVALUATION_LEGEND_BASE: EvaluationLegend[] = [
    {
        title: 'Keine Probleme',
        icon: 'check',
        iconClass: 'text-success',
    },
];

export const EVALUATION_LEGEND_NO_ABSENCES: EvaluationLegend[] = [
    ...EVALUATION_LEGEND_BASE,
    {
        title: 'Abwesend',
        icon: 'remove',
        iconClass: '',
    },
];

export const EVALUATION_LEGEND: EvaluationLegend[] = [
    ...EVALUATION_LEGEND_BASE,
    {
        title: 'Abwesend',
        icon: 'priority_high',
        iconClass: 'text-danger',
    },
    {
        title: 'Kein Arbeitstag',
        icon: 'remove',
        iconClass: '',
    },
    {
        title: 'Arbeitszeitverstoß',
        icon: 'clear',
        iconClass: 'text-danger',
    },
    {
        title: 'Arbeitszeitverstoß (in Toleranz)',
        icon: 'clear',
        iconClass: 'text-warning',
    },
    {
        title: 'Urlaub',
        icon: 'flight_takeoff',
        iconClass: '',
    },
    {
        title: 'Krank',
        icon: 'local_hospital',
        iconClass: '',
    },
    {
        title: 'Schule',
        icon: 'school',
        iconClass: '',
    },
    {
        title: 'Feiertag',
        icon: 'public',
        iconClass: '',
    },
    {
        title: 'Sonstiges',
        icon: 'block',
        iconClass: '',
    },
    {
        title: 'Stundenabbau',
        icon: 'access_time',
        iconClass: '',
    },
    {
        title: 'App',
        icon: 'smartphone',
        iconClass: 'link-color',
    },
    {
        title: 'Terminal',
        icon: 'nfc',
        iconClass: 'link-color',
    },
    {
        title: 'Browser',
        icon: 'computer',
        iconClass: 'link-color',
    },
];